import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { loadPagesForParent } from "@insite/client-framework/Store/Data/Pages/PagesActionCreators";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import updateLoadParameter from "@insite/client-framework/Store/Pages/NewsList/Handlers/UpdateLoadParameter";
import { CallApplyAccountShipToCollection } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SaveShipToCollection";
import translate from "@insite/client-framework/Translate";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import DynamicDropdown, { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import convertToNumberIfString from "@insite/mobius/utilities/convertToNumberIfString";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import searchBlogHandler from "@tCentro/Handlers/CENBlogSearchHandler";
import CENSetBlogSearchQuery from "@tCentro/Handlers/CENBlogSearchQueryHandler";
import cenSetSelectedArticleType from "@tCentro/Handlers/CenSelectedArticleTypeHandler";
import CENSetSelectedContentTab from "@tCentro/Handlers/CENSelectedContentTabHandler";
import CENDropDownIcon from "@tCentro/Icons/CENDropDownIcon";
import SearchIcon from "@tCentro/Icons/SearchIcon";
import { blogSearchModel } from "@tCentro/Services/CENBlogSearchService";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import sortBy from "lodash/sortBy";
import qs from "qs";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    defaultPageSize = "defaultPageSize",
    blogHeadContent = "blogHeadContent",
    pageId = "pageId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.defaultPageSize]: number;
        [fields.blogHeadContent]: string;
        [fields.pageId]: string;
    };
}

interface CategoryDropDownState {
    selectedContentTypeOptions: string[];
    isOpen: boolean;
    sortDropDownIsOpen: boolean;
    selectedArticleType: string;
    wrapperRef: any;
    searchInputRef: any;
    searchResult: any;
    searchQuery: any;
    searchValue: any;
    showDropdown: boolean;
    selectedSortOption: any;
    wrapperRefSort: any;
}

const sortOptions: Readonly<Record<string, string>> = {
    "1": "Publish Date Ascending",
    "2": "Publish Date Descending",
    "3": "Author Name A-Z",
    "4": "Author Name Z-A",
    "5": "Title A-Z",
    "6": "Title Z-A",
};

const selectedContentTypeOptions: Readonly<Record<string, string>> = {
    "0": "all",
    "1": "Articles",
    "2": "Case Studies",
    "3": "Videos",
    "4": "White Papers",
    "5": "Documents & Data Sheets",
    "6": "Tutorials",
    "7": "Announcements",
};

const selectArticleDropDownOptions = [
    { optionValue: "allArticlesType", optionText: "All Categories" },
    { optionValue: "AutomationRobotics", optionText: "Automation & Robotics" },
    { optionValue: "InstrumentationMeasurementControl", optionText: "Instrumentation, Measurement & Control" },
    { optionValue: "BulkMaterialHandlingDustCollection", optionText: "Bulk Material Handling & Dust Collection" },
    { optionValue: "FiltrationProcessSystems", optionText: "Filtration & Process Systems" },
    { optionValue: "PumpSeal", optionText: "Pump & Seal" },
    { optionValue: "ValveActuationEngineeredProducts", optionText: "Valve, Actuation & Engineered Products" },
    { optionValue: "General", optionText: "General" },
];

const mapStateToProps = (state: CustomApplicationState, _ownProps: WidgetProps) => {
    const location = getLocation(state);
    let newsListFilters: any = {};
    const pages = getDataView(state.data.pages, { parentNodeId: getCurrentPage(state).nodeId });
    let filteredPages = pages.value;
    let links: SafeDictionary<PageLinkModel> = {};
    if (filteredPages) {
        if (location.search) {
            const parsedQuery = parseQueryString<any>(location.search);
            newsListFilters = {
                AutomationRobotics: parsedQuery.AutomationRobotics ? true : undefined,
                InstrumentationMeasurementControl: parsedQuery.InstrumentationMeasurementControl ? true : undefined,
                BulkMaterialHandlingDustCollection: parsedQuery.BulkMaterialHandlingDustCollection ? true : undefined,
                FiltrationProcessSystems: parsedQuery.FiltrationProcessSystems ? true : undefined,
                PumpSeal: parsedQuery.PumpSeal ? true : undefined,
                ValveActuationEngineeredProducts: parsedQuery.ValveActuationEngineeredProducts ? true : undefined,
                General: parsedQuery.General ? true : undefined,
                contentType: parsedQuery.contentType,
                sort: parsedQuery.sort,
            };

            switch (newsListFilters.sort) {
                case "1":
                    filteredPages = sortBy(filteredPages, o => o.fields["publishDate"]).reverse();
                    break;
                case "2":
                    filteredPages = sortBy(filteredPages, o => o.fields["publishDate"]);
                    break;
                case "3":
                    filteredPages = sortBy(filteredPages, o => o.fields["author"]);
                    break;
                case "4":
                    filteredPages = sortBy(filteredPages, o => o.fields["author"]).reverse();
                    break;
                case "5":
                    filteredPages = sortBy(filteredPages, o => o.fields["title"]);
                    break;
                case "6":
                    filteredPages = sortBy(filteredPages, o => o.fields["title"]).reverse();
                    break;
                default:
                    filteredPages = sortBy(filteredPages, o => o.fields["publishDate"]).reverse();
                    break;
            }
        }
        if (!newsListFilters.sort) {
            filteredPages = sortBy(filteredPages, o => o.fields["publishDate"]).reverse();
        }

        links = filteredPages.reduce(
            (links, page) => ({ ...links, [page.nodeId]: getPageLinkByNodeId(state, page.nodeId) }),
            {},
        );
    }
    return {
        parentNodeId: getCurrentPage(state).nodeId,
        location,
        pages,
        links,
        parameter: state.pages.newsList.getNewsPagesParameters[getCurrentPage(state).nodeId] ?? {
            parentNodeId: getCurrentPage(state).nodeId,
        },
        newsListFilters,
        filteredPages,
        cenSelectedArticleType: state.t_components.selectedArticleType.selectedArticleType,
    };
};

const mapDispatchToProps = {
    loadPagesForParent,
    updateLoadParameter,
    cenSetSelectedArticleType,
    CENSetSelectedContentTab,
    searchBlogHandler,
    CENSetBlogSearchQuery,
};

type Props = OwnProps &
    CategoryDropDownState &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory;

export interface NewsListViewStyles {
    titleText?: TypographyProps;
    authorText?: LinkPresentationProps;
    publishDateText?: TypographyProps;
    listWrapper?: InjectableCss;
    newsWrapper?: InjectableCss;
    summaryWrapper?: GridItemProps;
    dateAndAuthorWrapper?: GridItemProps;
    readMoreLink?: LinkPresentationProps;
    pagination?: PaginationPresentationProps;
    linktext?: InjectableCss;
    introHeadingSeperator?: InjectableCss;
    articleImg?: GridItemProps;
    articleDate?: GridItemProps;
    subResourceNameLinkItem?: GridItemProps;
    filtersGrid?: GridContainerProps;
    articleDateListingGrid?: GridItemProps;
    container?: GridContainerProps;
    mainContainer?: InjectableCss;
    articleImgWrap?: InjectableCss;
    summaryContainer?: GridItemProps;
    filtersWrapper?: GridItemProps;
    filtersHeading?: InjectableCss;
    sortWrapper?: InjectableCss;
    sortSelect?: SelectPresentationProps;
    linkContainerStyles?: GridItemProps;
    categoryDropDownStyles?: DynamicDropdownPresentationProps;
    backgroundStyles?: InjectableCss;
    searchStyles?: TextFieldPresentationProps;
    filterSectionContainer?: InjectableCss;
    featuredPostsContent?: InjectableCss;
    featuredTitleStyles?: InjectableCss;
    firstIndexFeaturedPostsContainer?: InjectableCss;
    featuredPostsContainer?: InjectableCss;
    featuredPostsMainContainer?: InjectableCss;
    featuredPostsCardContainer?: InjectableCss;
    contentTypeWrapper?: InjectableCss;
    contentTypeChildWrapper?: InjectableCss;
    contentTypeButton?: ButtonPresentationProps;
    checkboxStyles?: CheckboxPresentationProps;
    articlesContentTypeStyles?: InjectableCss;
    buttonIconStyles?: IconPresentationProps;
    filterContentTextStyles?: InjectableCss;
    contentTypeTextStyles?: InjectableCss;
    firstIndexArticleImgWrap: InjectableCss;
    firstIndexh3: InjectableCss;
    articleh3: InjectableCss;
    containerWrapper: InjectableCss;
    featuredPostsBackgroundContainer?: InjectableCss;
    featuredPostsParentContainer?: InjectableCss;
}

export const newsListViewStyles: NewsListViewStyles = {
    featuredPostsParentContainer: {
        css: css`
            margin-top: 24px;
            margin-left: auto;
            margin-right: auto;
            max-width: 1800px;
            padding: 40px 64px 40px 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 16px;
                        padding-right: 16px;
                        max-width: 100%;
                    `,
                    css`
                        padding-left: 16px;
                        padding-right: 16px;
                        max-width: 100%;
                    `,
                    css`
                        padding-left: 16px;
                        padding-right: 16px;
                        max-width: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    featuredPostsBackgroundContainer: {
        css: css`
            background-color: #f2f2f2;
        `,
    },
    containerWrapper: {
        css: css`
            margin-top: 24px;
            max-width: 1800px;
            margin: auto;
            margin-top: 24px;
            padding-left: 64px;
            padding-right: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        padding-left: 16px;
                        padding-right: 16px;
                    `,
                    css`
                        max-width: 100%;
                        padding-left: 16px;
                        padding-right: 16px;
                    `,
                    css`
                        max-width: 100%;
                        padding-left: 16px;
                        padding-right: 16px;
                    `,

                    null,
                    null,
                ])};
        `,
    },
    firstIndexArticleImgWrap: {
        css: css`
            background: ${COLORS.white};
            height: auto;
            > img {
                object-fit: cover;
                aspect-ratio: 25 / 14;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            aspect-ratio: 25 / 14;
                        `,
                        css`
                            aspect-ratio: 25 / 14;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },

    articleh3: {
        css: css`
            span {
                font-family: Poppins;
                font-weight: 600;
                font-size: 24px;
                line-height: 32px;
                color: ${getProp("theme.typography.p.color")} !important;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        `,
    },
    firstIndexh3: {
        css: css`
            span {
                font-family: Poppins;
                font-weight: 600;
                font-size: 24px;
                line-height: 32px;
                color: ${getProp("theme.typography.p.color")} !important;
                display: -webkit-box;
                -webkit-line-clamp: 2 !important;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        `,
    },
    contentTypeTextStyles: {
        css: css`
            color: ${getProp("theme.typography.p.color")} !important;
            font-family: Poppins;
            font-weight: 700;
            font-size: 14px;
            line-height: 24px;
            letter-spacing: 0%;
            padding-left: 3px;
        `,
    },
    filterContentTextStyles: {
        css: css`
            color: ${getProp("theme.typography.p.color")} !important;
            font-family: Poppins;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            letter-spacing: 0%;
        `,
    },
    buttonIconStyles: {
        css: css`
            position: absolute;
            right: 13.75px;
            width: 12px !important;
        `,
    },
    articlesContentTypeStyles: {
        css: css`
            font-family: Poppins;
            font-weight: 400;
            font-style: italic;
            font-size: 12px;
            line-height: 16px;
        `,
    },
    checkboxStyles: {
        css: css`
            margin-top: 8px;
        `,
        typographyProps: {
            color: ` ${getProp("theme.typography.p.color")}`,
            css: css`
                font-family: Poppins;
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                letter-spacing: 0%;
                vertical-align: middle;
                color: ${getProp("theme.typography.p.color")};
            `,
        },
    },
    contentTypeButton: {
        css: css`
            display: flex;
            align-items: center;
            gap: 24px;
            background-color: white;
            border: 2px solid #f2f2f2;
            width: 100%;
            border-radius: 40px;
            span {
                color: ${getProp("theme.typography.p.color")} !important;

                &:hover {
                    color: ${getProp("theme.typography.p.color")} !important;
                }
            }
            &:hover {
                background-color: white !important;
                background: white;
                border-color: #f2f2f2;
            }
        `,
        color: ` ${getProp("theme.typography.p.color")};`,
    },
    contentTypeChildWrapper: {
        css: css`
            p {
                font-family: Poppins;
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                letter-spacing: 0%;
                vertical-align: middle;
                color: ${getProp("theme.typography.p.color")};
            }
            position: absolute;
            background: #f2f2f2;
            border: 1px solid #f2f2f2;
            padding: 8px 0px 8px 18px;
            width: 100%;
            margin-top: 10px;
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
            z-index: 10;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            > div[class^="CheckboxStyle"] {
                &:hover {
                    background-color: #e0dfe0;
                    cursor: pointer;
                }
            }
        `,
    },
    contentTypeWrapper: {
        css: css`
            position: relative;
            display: inline-block;
            flex-basis: 48%;
            max-width: 48%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: unset;
                        max-width: unset;
                    `,
                    css``,
                    css``,

                    css``,
                    css``,
                ])};
        `,
    },
    featuredPostsMainContainer: {
        css: css`
            display: grid;
            grid-template-columns: 3fr 1fr;
            gap: 24px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: 1fr;
                    `,
                    css`
                        grid-template-columns: 1fr;
                    `,
                    css`
                        grid-template-columns: repeat(2, 1fr);
                    `,
                    css``,
                    css``,
                ])};
        `,
    },
    featuredPostsCardContainer: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    featuredPostsContainer: {
        css: css`
            grid-column: 2;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-column: auto;
                    `,
                    css`
                        grid-column: auto;
                    `,
                    css`
                        grid-column: auto;
                    `,
                    css``,
                ])}
        `,
    },
    firstIndexFeaturedPostsContainer: {
        css: css`
            /* grid-row: span 3;
            grid-column: 1; */
            grid-row-start: 1;
            grid-row-end: 3;
            background: white;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-row-start: 1;
                        grid-row-end: 1;
                    `,
                    css`
                        grid-row-start: 1;
                        grid-row-end: 1;
                    `,
                    css`
                        grid-row-start: 1;
                        grid-row-end: 1;
                        &:first-child {
                            grid-column: span 3; /* 1st div takes full width */
                        }
                    `,
                    css``,
                ])}
        `,
    },
    featuredTitleStyles: {
        css: css`
            font-family: Poppins;
            font-weight: 700;
            font-size: 32px;
            line-height: 32px;
            color: ${getProp("theme.typography.p.color")};
            margin-bottom: 24px;
        `,
    },
    featuredPostsContent: {
        css: css`
            background: white;
            padding: 32px;
            display: flex;
            flex-direction: column;
            gap: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 25px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
            .featuredCategory {
                width: max-content;
                color: ${getColor("primary")};
                border: 1px solid ${getColor("primary")};
                background: white;
                padding: 4px 12px;
                font-family: Poppins;
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                letter-spacing: 0%;
                border-radius: 24px;
            }
            a {
                span {
                    font-family: Poppins;
                    font-weight: 600;
                    font-size: 24px;
                    line-height: 32px;
                    color: ${getProp("theme.typography.p.color")};
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        `,
    },
    searchStyles: {
        sizeVariant: "default",
        iconProps: {
            src: SearchIcon,
            css: css`
                width: 30px !important;
            `,
        },
        border: "underline",
        cssOverrides: {
            formField: css``,
            inputSelect: css`
                border-radius: 40px;
                background-color: #f2f2f2;
                border: none;
                padding-left: 16px;
                padding-right: 16px;
                font-family: Poppins;
                font-weight: 400;
                font-size: 14px;
                line-height: 24px;
                letter-spacing: 0%;
                color: ${getColor("text.main")};
                &:focus {
                    border-radius: 40px;
                    border: none;
                    padding-left: 16px;
                }
            `,
        },
    },
    filterSectionContainer: {
        css: css`
            border: 4px solid #f2f2f2;
            padding: 24px 32px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px;

            margin-top: 2px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: unset !important;
                        background: linear-gradient(90deg, #8f0446 0%, #1d2d36 100%);
                        padding: 16px 16px;
                    `,
                    css`
                        grid-template-columns: unset !important;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    backgroundStyles: {
        css: css`
            width: 100%;
            height: 16px;
            background: linear-gradient(90deg, #8f0446 0%, #1d2d36 100%);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    categoryDropDownStyles: {
        cssOverrides: {
            list: css`
                right: 0px;
                max-width: 100%;
                top: 45px;
            `,
            selectedText: css`
                padding: 10px 0px 12px 24px;
            `,
            option: css`
                background-color: #f2f2f2;
                color: ${getProp("theme.typography.p.color")};
                font-family: Poppins;
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                &:hover {
                    background-color: #e0dfe0;
                }
            `,

            formInputWrapper: css`
                font-family: Poppins;
                font-weight: 700;
                font-size: 14px;
                line-height: 24px;
                color: ${getProp("theme.typography.p.color")};
                ul {
                    background-color: #f2f2f2;
                    padding: 10px 0px;
                }
            `,
            inputSelect: css`
                border: 2px solid #262525;
                border-radius: 24px;
                height: 48px;
                cursor: default;
                caret-color: transparent;
                user-select: none;
                &:focus-within {
                    border: 2px solid ${getProp("theme.typography.p.color")};
                    border-radius: 24px;
                    height: 48px;
                }
            `,
        },

        iconProps: {
            src: CENDropDownIcon,
            css: css`
                top: 8px !important;
                right: 24px !important;
                width: 28px !important;
                height: 28px !important;
            `,
        },
    },
    filtersWrapper: {
        width: [12, 12, 12, 9, 9],
        css: css``,
    },

    mainContainer: {
        css: css`
            width: 100%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        margin-top: 40px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    filtersGrid: {
        css: css`
            max-width: 1800px;
            padding-left: 64px;
            padding-right: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        padding-left: 16px;
                        padding-right: 16px;
                    `,
                    css`
                        max-width: 100%;
                        padding-left: 16px;
                        padding-right: 16px;
                    `,
                    css`
                        max-width: 100%;
                        padding-left: 16px;
                        padding-right: 16px;
                    `,
                    null,
                    null,
                ])}
        `,
    },

    subResourceNameLinkItem: {
        width: [12, 12, 5, 3, 3],
        css: css`
            align-self: flex-end;
        `,
    },

    authorText: {
        css: css`
            > span {
                font-weight: ${TYPOGRAPHY.weight.bold};
                margin-left: 4px;
                color: ${getColor("text.link")} !important;
                font-family: Poppins;
                font-weight: 600 !important;
                font-size: 12px !important;
                line-height: 16px !important;
                letter-spacing: 0%;
            }
        `,
    },

    publishDateText: {
        css: css`
            color: ${getColor("text.link")};
            font-family: Poppins;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            margin-right: 4px;
            > span {
                padding: 5px;
                color: #9e9d9e;
            }
        `,
    },

    articleImgWrap: {
        css: css`
            width: 100%;
            height: auto;
            background: ${COLORS.white};

            > img {
                object-fit: cover;
                aspect-ratio: 25 / 14;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            aspect-ratio: 25 / 14;
                        `,
                        css`
                            aspect-ratio: 25 / 14;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
    sortWrapper: {
        css: css`
            display: flex;
            gap: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    sortSelect: {
        cssOverrides: {
            inputSelect: css`
                border-radius: 24px;
                border: none;
                padding: 0px;
                font-family: Poppins;
                font-weight: 700;
                font-size: 14px;
                line-height: 24px;
                letter-spacing: 0%;
                color: ${getProp("theme.typography.p.color")};
                &:focus {
                    border: none;
                    padding: 0px;
                }
                option {
                    font-family: Poppins;
                    font-weight: 600;
                    font-size: 12px;
                    line-height: 16px;
                    color: ${getProp("theme.typography.p.color")};
                    background-color: #f2f2f2;
                    padding: 8px 0px 8px 16px;
                    &:hover {
                        background-color: #e0dfe0;
                    }
                }
            `,
            formInputWrapper: css`
                width: 100%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ])}
            `,
            formField: css`
                border: 2px solid #f2f2f2;
                border-radius: 40px;
                padding: 0px 16px;
                flex-basis: 48%;
                max-width: 48%;
                position: relative;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            background: white;
                            max-width: none;
                        `,
                        css``,

                        null,
                        null,
                        null,
                    ])}
            `,
        },
        labelProps: {
            css: css`
                width: auto;
                padding-right: 4px !important;
                overflow: initial;
                text-overflow: initial;
                font-weight: 400 !important;
                color: ${getProp("theme.typography.p.color")} !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            text-align: left;
                            margin-bottom: 5px;
                        `,
                        css`
                            text-align: left;
                            margin-bottom: 5px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            `,
        },
        iconProps: {
            src: CENDropDownIcon,
            css: css`
                position: absolute;
                right: 0px !important;
                top: 6px !important;
                width: 28px !important;
                height: 28px !important;
            `,
        },
    },
};

const styles = newsListViewStyles;
const contentTypeMapping = {
    "1": { value: "Articles", name: "Articles" },
    "2": { value: "CaseStudies", name: "Case Studies" },
    "3": { value: "Videos", name: "Videos" },
    "4": { value: "WhitePapers", name: "White Papers" },
    "5": { value: "DocumentsDataSheets", name: "Documents & Data Sheets" },
    "6": { value: "Tutorials", name: "Tutorials" },
    "7": { value: "Announcements", name: "Announcements" },
};
class CENNewsListView extends React.Component<Props, CategoryDropDownState> {
    constructor(props: Props) {
        super(props);

        const queryString = parseQueryString<any>(props.location.search);

        let selectedArticleType = "allArticlesType";
        const contentTypeParam = queryString.contentType || "";
        const selectedContentTypes = contentTypeParam.split(",").map((type: string) => type.trim());
        const queryParams = new URLSearchParams(props.location?.search);
        const searchValue = queryParams?.get("search") ? queryParams?.get("search") : "";
        const selectedContentTypeIds = selectedContentTypes
            .map((name: string) => {
                const contentType = Object.values(contentTypeMapping).find(item => item.value === name);
                return contentType
                    ? (Object.keys(contentTypeMapping) as Array<keyof typeof contentTypeMapping>).find(
                          id => contentTypeMapping[id].value === name,
                      )
                    : null;
            })
            .filter(Boolean);

        if (queryString.AutomationRobotics === "true") {
            selectedArticleType = "AutomationRobotics";
        } else if (queryString.InstrumentationMeasurementControl === "true") {
            selectedArticleType = "InstrumentationMeasurementControl";
        } else if (queryString.BulkMaterialHandlingDustCollection === "true") {
            selectedArticleType = "BulkMaterialHandlingDustCollection";
        } else if (queryString.FiltrationProcessSystems === "true") {
            selectedArticleType = "FiltrationProcessSystems";
        } else if (queryString.PumpSeal === "true") {
            selectedArticleType = "PumpSeal";
        } else if (queryString.ValveActuationEngineeredProducts === "true") {
            selectedArticleType = "ValveActuationEngineeredProducts";
        } else if (queryString.General === "true") {
            selectedArticleType = "General";
        }

        this.state = {
            selectedContentTypeOptions: selectedContentTypeIds,
            isOpen: false,
            sortDropDownIsOpen: false,
            selectedArticleType,
            wrapperRef: React.createRef(),
            searchInputRef: React.createRef(),
            searchResult: [],
            searchQuery: searchValue,
            searchValue,
            showDropdown: false,
            selectedSortOption: "1",
            wrapperRefSort: React.createRef(),
        };
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);

        if (this.state.searchValue !== "") {
            this.props.searchBlogHandler({
                searchQuery: this.state.searchValue,
                onSuccess: (result?: blogSearchModel) => {
                    this.setState({ searchResult: result });
                },
            });
        }
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = (event: MouseEvent) => {
        if (this.state.wrapperRef.current && !this.state.wrapperRef.current.contains(event.target as Node)) {
            this.setState({ isOpen: false });
        }
        if (this.state.wrapperRefSort.current && !this.state.wrapperRefSort.current.contains(event.target as Node)) {
            this.setState({ showDropdown: false });
        }
    };

    contentTypeMapping = {
        "1": "isArticlesContentType",
        "2": "isCaseStudiesContentType",
        "3": "isVideosContentType",
        "4": "isWhitePapersContentType",
        "5": "isDocumentsDataSheetsContentType",
        "6": "isTutorialsContentType",
        "7": "isAnnouncementsContentType",
    };

    handleCheckboxChange = (contentTypeId: string) => {
        this.setState(prevState => {
            let newSelectedOptions = [...prevState.selectedContentTypeOptions];

            if (contentTypeId === "0") {
                newSelectedOptions = newSelectedOptions.includes("0") ? [] : Object.keys(selectedContentTypeOptions);
            } else {
                const isSelected = newSelectedOptions.includes(contentTypeId);
                newSelectedOptions = isSelected
                    ? newSelectedOptions.filter(id => id !== contentTypeId)
                    : [...newSelectedOptions, contentTypeId];

                const allExceptAll = Object.keys(selectedContentTypeOptions).filter(id => id !== "0");
                if (allExceptAll.every(id => newSelectedOptions.includes(id))) {
                    newSelectedOptions = Object.keys(selectedContentTypeOptions);
                } else {
                    newSelectedOptions = newSelectedOptions.filter(id => id !== "0");
                }
            }
            const updatedNewsListFilters = { ...this.props.newsListFilters };

            if (newSelectedOptions.length > 0) {
                const selectedNames = newSelectedOptions.map(id =>
                    selectedContentTypeOptions[id].replace(/[^\w]/g, ""),
                );
                updatedNewsListFilters["contentType"] = selectedNames.join(",");
                this.updateQueryString(1, this.props.parameter.pageSize, updatedNewsListFilters);
            } else {
                updatedNewsListFilters["contentType"] = undefined;
                this.updateQueryString(1, this.props.parameter.pageSize, updatedNewsListFilters);
            }

            return { selectedContentTypeOptions: newSelectedOptions };
        });
    };

    getFilteredFeaturedPosts = () => {
        const { selectedArticleType } = this.state;
        let featuredPosts =
            this.props.cenSelectedArticleType === "allArticlesType"
                ? this.props.filteredPages
                : this.props.filteredPages?.filter(
                      post => post.fields.articlesType === this.props.cenSelectedArticleType,
                  );

        if (this.state.selectedContentTypeOptions.includes("0")) {
            return featuredPosts;
        }

        if (this.state.selectedContentTypeOptions.length > 0) {
            featuredPosts = featuredPosts?.filter((item: any) =>
                this.state.selectedContentTypeOptions.some(
                    contentTypeId =>
                        item.fields[this.contentTypeMapping[contentTypeId as keyof typeof this.contentTypeMapping]],
                ),
            );
        }
        if (this.state.searchQuery !== "") {
            featuredPosts =
                this.state.searchResult?.length === 0
                    ? []
                    : featuredPosts?.filter((post: any) => this.state.searchResult?.includes(post.name));
        }

        return featuredPosts;
    };

    UNSAFE_componentWillMount() {
        if (!this.props.pages.value && !this.props.pages.isLoading) {
            this.props.loadPagesForParent(this.props.parameter);
        }
        // this.checkQueryString();
    }

    componentDidUpdate() {
        if (!this.props.pages.value && !this.props.pages.isLoading) {
            this.props.loadPagesForParent(this.props.parameter);
        }
        if (this.state.searchResult) {
            this.props.CENSetBlogSearchQuery({ searchQuery: this.state.searchResult });
        }
        this.checkQueryString();
    }

    updateQueryString(page: number, pageSize?: number, newsFilters?: any) {
        const filters = newsFilters || this.props.newsListFilters || undefined;
        const {
            history,
            location: { pathname },
        } = this.props;
        let newLocation = `${pathname}?page=${page}`;
        if (pageSize) {
            newLocation += `&pageSize=${pageSize}`;
        }
        if (filters) {
            const filterQuery = qs.stringify(filters, { arrayFormat: "comma", skipNulls: true });
            if (filterQuery) {
                newLocation += `&${filterQuery}`;
            }
        }
        if (this.state.searchQuery) {
            newLocation += `&search=${this.state.searchQuery}`;
        }
        history.push(newLocation);
    }
    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, toggleAutoComplete = true) => {
        const newQuery = event.target.value;
        this.setState({ searchValue: newQuery });
    };
    searchClick = () => {
        const getSearchQuery = this.state.searchInputRef.current?.value.trim().toLowerCase();

        this.setState({ searchQuery: getSearchQuery }, () => {
            this.updateQueryString(1, this.props.parameter.pageSize, this.props.newsListFilters);
        });
        if (this.state.searchValue !== "") {
            this.props.searchBlogHandler({
                searchQuery: getSearchQuery,
                onSuccess: (result?: blogSearchModel) => {
                    this.setState({ searchResult: result });
                },
            });
        } else {
            this.setState({ searchResult: [] });
        }
    };
    checkQueryString() {
        const {
            location: { search },
            parameter: { page, pageSize, parentNodeId },
        } = this.props;
        const queryString = parseQueryString<any>(search);

        const parsedQueryString = parseQueryString<{ page?: string; pageSize?: string }>(search);
        const newPage = parsedQueryString.page ? convertToNumberIfString(parsedQueryString.page) : undefined;
        const newPageSize = parsedQueryString.pageSize
            ? convertToNumberIfString(parsedQueryString.pageSize)
            : undefined;
        let selectedArticleType = "allArticlesType";

        if (queryString.AutomationRobotics === "true") {
            selectedArticleType = "AutomationRobotics";
        } else if (queryString.InstrumentationMeasurementControl === "true") {
            selectedArticleType = "InstrumentationMeasurementControl";
        } else if (queryString.BulkMaterialHandlingDustCollection === "true") {
            selectedArticleType = "BulkMaterialHandlingDustCollection";
        } else if (queryString.FiltrationProcessSystems === "true") {
            selectedArticleType = "FiltrationProcessSystems";
        } else if (queryString.PumpSeal === "true") {
            selectedArticleType = "PumpSeal";
        } else if (queryString.ValveActuationEngineeredProducts === "true") {
            selectedArticleType = "ValveActuationEngineeredProducts";
        } else if (queryString.General === "true") {
            selectedArticleType = "General";
        }
        if (newPage !== page || newPageSize !== pageSize) {
            this.props.updateLoadParameter({
                page: newPage,
                pageSize: newPageSize,
                parentNodeId,
            });
        }
        if (selectedArticleType.length > 0) {
            this.props.cenSetSelectedArticleType({ selectedArticleType });
        }
        if (this.state.selectedContentTypeOptions) {
            this.props.CENSetSelectedContentTab({ selectedContentType: this.state.selectedContentTypeOptions });
        }
    }

    onChangeSortHandler = (selectedValue: string) => {
        const newsListFilters = { ...this.props.newsListFilters };
        newsListFilters.sort = selectedValue;
        this.updateQueryString(1, this.props.parameter.pageSize, newsListFilters);
    };

    handleOptionChange = (selectedValue?: string) => {
        const newsListFilters = { ...this.props.newsListFilters };
        const articleCategories = [
            "AutomationRobotics",
            "InstrumentationMeasurementControl",
            "BulkMaterialHandlingDustCollection",
            "FiltrationProcessSystems",
            "PumpSeal",
            "ValveActuationEngineeredProducts",
            "General",
        ];
        if (selectedValue) {
            const cleanedStr = selectedValue.replace(/[^\w]/g, "");
            articleCategories.forEach(category => {
                if (category !== cleanedStr) {
                    delete newsListFilters[category];
                }
            });
            newsListFilters[cleanedStr] = cleanedStr !== "allArticlesType" ? "true" : undefined;
        }

        this.setState({ selectedArticleType: selectedValue || "allArticlesType" });
        this.updateQueryString(1, this.props.parameter.pageSize, newsListFilters);
    };

    toggleDropdown = () => {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    };
    toggleDropdownSort = () => {
        this.setState(prevState => ({ showDropdown: !prevState.showDropdown }));
    };

    handleSortChange = (sortId: any) => {
        this.setState({ selectedSortOption: sortId, showDropdown: false });
        this.onChangeSortHandler(sortId);
    };
    render() {
        const { isOpen, selectedArticleType, showDropdown } = this.state;
        const filteredFeaturedPosts = this.getFilteredFeaturedPosts();
        const {
            links,
            pages: { value: pages },
            cenSelectedArticleType,
        } = this.props;

        if (!pages) {
            return null;
        }

        const dropdownOptions = selectArticleDropDownOptions.map(articleType => ({
            optionValue: articleType.optionValue,
            optionText: articleType.optionText,
        }));

        const isFeaturedFilterPost = filteredFeaturedPosts
            ?.filter((item: any) => item.fields.isFeaturedPosts)
            .slice(0, 3);

        const getArticleTypeLabel = (articleType: string) => {
            switch (articleType) {
                case "AutomationRobotics":
                    return "Automation & Robotics";
                case "InstrumentationMeasurementControl":
                    return "Instrumentation, Measurement & Control";
                case "BulkMaterialHandlingDustCollection":
                    return "Bulk Material Handling & Dust Collection";
                case "FiltrationProcessSystems":
                    return "Filtration & Process Systems";
                case "PumpSeal":
                    return "Pump & Seal";
                case "ValveActuationEngineeredProducts":
                    return "Valve, Actuation & Engineered Products";
                case "General":
                    return "General";
                default:
                    return "";
            }
        };
        // this.props.CENSetBlogSearchQuery({ searchQuery: this.state.searchResult });
        return (
            <>
                <StyledWrapper {...styles.mainContainer}>
                    <GridContainer {...styles.filtersGrid}>
                        <GridItem {...styles.filtersWrapper}>
                            <Typography {...styles.filtersHeading}>
                                {parse(transformContentHtml(this.props.fields.blogHeadContent), parserOptions)}
                            </Typography>
                        </GridItem>
                        <GridItem {...styles.subResourceNameLinkItem} id="categoryGrid">
                            {dropdownOptions && (
                                <DynamicDropdown
                                    onSelectionChange={this.handleOptionChange}
                                    options={dropdownOptions}
                                    placeholder={translate("All Categories")}
                                    selected={cenSelectedArticleType}
                                    {...styles.categoryDropDownStyles}
                                />
                            )}
                        </GridItem>
                    </GridContainer>

                    <StyledWrapper {...styles.containerWrapper}>
                        <StyledWrapper {...styles.backgroundStyles}></StyledWrapper>
                        <StyledWrapper {...styles.filterSectionContainer}>
                            <TextField
                                {...styles.searchStyles}
                                ref={this.state.searchInputRef}
                                iconClickableProps={{ onClick: () => this.searchClick() }}
                                value={this.state.searchValue}
                                onChange={this.handleInputChange}
                                placeholder={translate("Search topics, categories, and more")}
                                autoComplete="off"
                                clickableText={translate("submit search")}
                                id="blogSearch"
                                data-test-selector="headerSearchInputTextField"
                                className="search-input"
                                onKeyDown={event => {
                                    if (event.key === "Enter") {
                                        event.preventDefault();
                                        this.searchClick();
                                    }
                                }}
                            />
                            <StyledWrapper {...styles.sortWrapper}>
                                <StyledWrapper {...styles.contentTypeWrapper} ref={this.state.wrapperRef}>
                                    <Button {...styles.contentTypeButton} onClick={this.toggleDropdown}>
                                        <StyledWrapper>
                                            <Typography as="span" {...styles.filterContentTextStyles}>
                                                {translate("Filter:")}
                                            </Typography>
                                            <Typography as="span" {...styles.contentTypeTextStyles}>
                                                {this.state.selectedContentTypeOptions.length > 0
                                                    ? translate(
                                                          `${this.state.selectedContentTypeOptions.length}" Content Types"`,
                                                      )
                                                    : translate("Select Content Types")}
                                            </Typography>
                                        </StyledWrapper>
                                        <Icon src={CENDropDownIcon} {...styles.buttonIconStyles} />
                                    </Button>
                                    {isOpen && (
                                        <StyledWrapper {...styles.contentTypeChildWrapper}>
                                            <Typography as="p">Content Types</Typography>
                                            <Checkbox
                                                {...styles.checkboxStyles}
                                                checked={this.state.selectedContentTypeOptions.includes("0")}
                                                onChange={() => this.handleCheckboxChange("0")}
                                            >
                                                All
                                            </Checkbox>
                                            {Object.keys(selectedContentTypeOptions).map(
                                                contentTypeId =>
                                                    contentTypeId !== "0" && (
                                                        <Checkbox
                                                            key={contentTypeId}
                                                            {...styles.checkboxStyles}
                                                            checked={this.state.selectedContentTypeOptions.includes(
                                                                contentTypeId,
                                                            )}
                                                            onChange={() => this.handleCheckboxChange(contentTypeId)}
                                                        >
                                                            {selectedContentTypeOptions[contentTypeId]}
                                                        </Checkbox>
                                                    ),
                                            )}
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                                <StyledWrapper {...styles.contentTypeWrapper} ref={this.state.wrapperRefSort}>
                                    <Button {...styles.contentTypeButton} onClick={this.toggleDropdownSort}>
                                        <StyledWrapper>
                                            <Typography as="span" {...styles.filterContentTextStyles}>
                                                {translate("Sort by:")}
                                            </Typography>
                                            <Typography as="span" {...styles.contentTypeTextStyles}>
                                                {sortOptions[this.state.selectedSortOption] || translate("Select sort")}
                                            </Typography>
                                        </StyledWrapper>
                                        <Icon src={CENDropDownIcon} {...styles.buttonIconStyles} />
                                    </Button>
                                    {showDropdown && (
                                        <StyledWrapper {...styles.contentTypeChildWrapper}>
                                            {Object.keys(sortOptions).map(sortId => (
                                                <Typography
                                                    key={sortId}
                                                    as="p"
                                                    onClick={() => this.handleSortChange(sortId)}
                                                    style={{
                                                        cursor: "pointer",
                                                        padding: "8px",
                                                        backgroundColor:
                                                            this.state.selectedSortOption === sortId
                                                                ? "#f0f0f0"
                                                                : "transparent",
                                                        borderRadius: "4px",
                                                    }}
                                                >
                                                    {sortOptions[sortId]}
                                                </Typography>
                                            ))}
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>

                    {isFeaturedFilterPost && isFeaturedFilterPost.length > 0 && (
                        <StyledWrapper {...styles.featuredPostsBackgroundContainer}>
                            <StyledWrapper {...styles.featuredPostsParentContainer}>
                                <>
                                    <Typography as="p" {...styles.featuredTitleStyles}>
                                        {translate(`Featured Posts`)}{" "}
                                        {selectedArticleType !== "allArticlesType" &&
                                            `in ${getArticleTypeLabel(selectedArticleType)}`}
                                    </Typography>
                                    <StyledWrapper {...styles.featuredPostsMainContainer}>
                                        {isFeaturedFilterPost?.map((page, index) => {
                                            return (
                                                page.fields["isFeaturedPosts"] && (
                                                    <StyledWrapper
                                                        key={index}
                                                        {...(index === 0
                                                            ? styles.firstIndexFeaturedPostsContainer
                                                            : styles.featuredPostsContainer)}
                                                    >
                                                        <StyledWrapper {...styles.featuredPostsCardContainer}>
                                                            <LazyImage
                                                                key={page.id}
                                                                src={page.fields["image"] ? page.fields["image"] : ""}
                                                                {...(index === 0
                                                                    ? styles.firstIndexArticleImgWrap
                                                                    : styles.articleImgWrap)}
                                                                altText={page.fields["title"] || ""}
                                                            ></LazyImage>
                                                            <StyledWrapper {...styles.featuredPostsContent}>
                                                                <Typography as="p" className="featuredCategory">
                                                                    {`${getArticleTypeLabel(
                                                                        page.fields["articlesType"],
                                                                    )}`}
                                                                </Typography>
                                                                <StyledWrapper>
                                                                    {page.fields["publishDate"] && (
                                                                        <Typography
                                                                            {...styles.publishDateText}
                                                                            data-test-selector="newslist_publishdate"
                                                                        >
                                                                            <LocalizedDateTime
                                                                                dateTime={
                                                                                    new Date(page.fields["publishDate"])
                                                                                }
                                                                                options={{
                                                                                    year: "numeric",
                                                                                    month: "long",
                                                                                    day: "numeric",
                                                                                }}
                                                                            />
                                                                        </Typography>
                                                                    )}
                                                                    {page.fields["author"] && (
                                                                        <>
                                                                            <Typography as="span">|</Typography>
                                                                            <Link
                                                                                {...styles.authorText}
                                                                                href={
                                                                                    page.fields["authorLink"]
                                                                                        ? page.fields["authorLink"]
                                                                                        : ""
                                                                                }
                                                                                data-test-selector="newslist_author"
                                                                            >
                                                                                {page.fields["author"]}
                                                                            </Link>
                                                                        </>
                                                                    )}
                                                                </StyledWrapper>
                                                                <Typography
                                                                    as="p"
                                                                    {...styles.articlesContentTypeStyles}
                                                                >
                                                                    {[
                                                                        page.fields["isArticlesContentType"] &&
                                                                            "Articles",
                                                                        page.fields["isCaseStudiesContentType"] &&
                                                                            "Case Studies",
                                                                        page.fields["isVideosContentType"] && "Videos",
                                                                        page.fields["isWhitePapersContentType"] &&
                                                                            "White Papers",
                                                                        page.fields[
                                                                            "isDocumentsDataSheetsContentType"
                                                                        ] && "Documents & Data Sheets",
                                                                        page.fields["isTutorialsContentType"] &&
                                                                            "Tutorials",
                                                                        page.fields["isAnnouncementsContentType"] &&
                                                                            "Announcements",
                                                                    ]
                                                                        .filter(Boolean)
                                                                        .join(", ")}
                                                                </Typography>

                                                                <StyledWrapper>
                                                                    <Link
                                                                        href={links[page.nodeId]?.url}
                                                                        {...(index === 0
                                                                            ? styles.firstIndexh3
                                                                            : styles.articleh3)}
                                                                    >
                                                                        {page.name}
                                                                    </Link>
                                                                </StyledWrapper>
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                )
                                            );
                                        })}
                                    </StyledWrapper>
                                </>
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            </>
        );
    }
}

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(CENNewsListView)),
    definition: {
        group: "News List",
        displayName: "CEN News List View",
        allowedContexts: ["NewsListPage"],
        fieldDefinitions: [
            {
                name: fields.defaultPageSize,
                editorTemplate: "IntegerField",
                defaultValue: 5,
                fieldType: "General",
                min: 1,
                max: 20,
            },
            {
                name: fields.blogHeadContent,
                displayName: "Blog Description",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.pageId,
                displayName: "Page Id",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
